import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../utils/axiosInstance";
import { SignupPayload, UserAuth } from "./authTypes";

export const signupAuthUser = createAsyncThunk(
  "auth/signup",
  async (payload: SignupPayload, thunkAPI) => {
    try {
      const response = await API.post("/auth/sign-up", payload);
      return response.data as any;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message || "Sign Up failed");
    }
  }
);

export const signOutAuthUser = createAsyncThunk(
  "auth/signOut",
  async (_, thunkAPI) => {
    try {
      await API.post("/auth/logout");
      return null;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message || "Sign Out failed");
    }
  }
);

export const loginAuthUser = createAsyncThunk(
  "auth/login",
  async (payload: UserAuth, thunkAPI) => {
    try {
      const response = await API.post("/auth/login", payload);
      return response.data.auth as UserAuth["data"];
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message || "Login failed");
    }
  }
);
